import _ from 'lodash'
import { Field } from 'redux-form'
import { Row, Col } from 'antd'
import {
  RadioGroupInputField,
  MenuSelectField,
  CheckboxMenuSelectField
} from '../../../../Common/Form'
import { getFieldName } from '../../../helper/batch'
import styles from './index.css'

const ProductModels = props => {
  const {
    fieldPrefix,
    listing
  } = props
  const {
    layerOneModel,
    layerTwoModel
  } = listing
  return (
    <>
      <div className={styles.hasSpecLevel}>
        <Field
          name={getFieldName(fieldPrefix, 'hasSpecLevel')}
          data-role='with-spec-level-radio'
          component={RadioGroupInputField}
          options={[
            { label: '無選項', value: false },
            { label: '有選項', value: true }
          ]}
          disabled
        />
      </div>
      {!_.isEmpty(layerOneModel) && (
        <Row className={styles.layerModel}>
          <Col span={8}>
            <Field
              name={getFieldName(fieldPrefix, 'layerOneModel.specOptionValues')}
              component={MenuSelectField}
              options={layerOneModel.specOptions}
              className={styles.specSelect}
              disabled
            />
          </Col>
          <Col span={16}>
            <Field
              name={getFieldName(fieldPrefix, 'layerOneModel.selectedValueOptionValues')}
              component={CheckboxMenuSelectField}
              options={layerOneModel.selectedValueOptions}
              className={styles.selectedValueSelect}
              disabled
            />
          </Col>
        </Row>
      )}
      {!_.isEmpty(layerTwoModel) && (
        <Row className={styles.layerModel}>
          <Col span={8}>
            <Field
              name={getFieldName(fieldPrefix, 'layerTwoModel.specOptionValues')}
              component={MenuSelectField}
              options={layerTwoModel.specOptions}
              className={styles.specSelect}
              disabled
            />
          </Col>
          <Col span={16}>
            <Field
              name={getFieldName(fieldPrefix, 'layerTwoModel.selectedValueOptionValues')}
              component={CheckboxMenuSelectField}
              options={layerTwoModel.selectedValueOptions}
              className={styles.selectedValueSelect}
              disabled
            />
          </Col>
        </Row>
      )}
    </>
  )
}

export default ProductModels
